import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { FormControl, FormControlLabel, Radio, RadioGroup, TextField } from '@material-ui/core';
import { useState } from 'react';
import {
    isDisabledAllFieldCsv
} from '../handler/KnowledgeUploadCsvHandler';
import CheckIconRadio from '../icons/CheckIconRadio';
import CheckedIconRadio from '../icons/CheckedIconRadio';
import IconDisabledRadio from '../icons/IconDisabledRadio';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import I18n from '@/rI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function WebCrawlerSetting({
    layer,
    setLayer,
    setErrorList,
    errorList,
    fileTypes,
    setFileTypes,
    password,
    setPassword,
    userName,
    setUserName,
    handleStatus,
    setIsEdited
}) {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const [isShowSettingPermission, setIsShowSettingPermission] = useState(false);
    // const invalidCharsLimitValue = ['.', '-', '+', 'e', 'E', ',', '/'];
    const fileTypesSupport = [
        'txt',
        'doc',
        'docx',
        'pdf',
        'jpg',
        'jpeg',
        'png',
        'gif',
        'bmp',
        'tiff',
        'tif',
        'jfif',
        'jfi',
        'jif',
        'mp3',
        'wav',
        'aac',
        'mp4',
        'avi',
        'mov',
        'wmv',
        'zip',
        'rar',
        'targz',
        'csv',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
        'json',
        'js',
        'html',
        'css',
        'py',
        'java',
        'cpp',
        'gz'
    ];

    const onBlurFileTypes = e => {
        let value = e.target.value;

        if (Utils.isEmptyString(value?.trim())) {
            return setErrorList(prev => ({ ...prev, fileTypes: I18n.get('COMMSG014') }));
        }

        if (value.length > Constant.UPLOAD_CSV_KNOWLEDGE.MAX_LENGTH_FILE_TYPES) {
            return setErrorList(prev => ({
                ...prev,
                fileTypes: I18n.get('COMMSG037').replace('＜X＞', Constant.UPLOAD_CSV_KNOWLEDGE.MAX_LENGTH_FILE_TYPES)
            }));
        }

        let enteredTypes = value?.split(',')?.map(type => type.toLowerCase().trim());

        for (let i = 0; i < enteredTypes.length; i++) {
            if (!fileTypesSupport.includes(enteredTypes[i])) {
                return setErrorList(prev => ({ ...prev, fileTypes: I18n.get('COMMSG070') }));
            }
        }

        setFileTypes(e.target.value?.toLowerCase().trim());

        return setErrorList(prev => {
            let prevClone = { ...prev };
            delete prevClone.fileTypes;
            return prevClone;
        });
    };

    const onBlurAuthenticatedUsername = e => {
        let value = e.target.value;

        if (value.length > Constant.UPLOAD_CSV_KNOWLEDGE.MAX_LENGTH_AUTHENTICATION) {
            return setErrorList(prev => ({
                ...prev,
                userName: I18n.get('COMMSG037').replace('＜X＞', Constant.UPLOAD_CSV_KNOWLEDGE.MAX_LENGTH_AUTHENTICATION)
            }));
        }

        return setErrorList(prev => {
            let prevClone = { ...prev };
            delete prevClone.userName;
            return prevClone;
        });
    };

    const onBlurAuthenticatedPassword = e => {
        let value = e.target.value;

        if (value.length > Constant.UPLOAD_CSV_KNOWLEDGE.MAX_LENGTH_AUTHENTICATION) {
            return setErrorList(prev => ({
                ...prev,
                password: I18n.get('COMMSG037').replace('＜X＞', Constant.UPLOAD_CSV_KNOWLEDGE.MAX_LENGTH_AUTHENTICATION)
            }));
        }

        return setErrorList(prev => {
            let prevClone = { ...prev };
            delete prevClone.password;
            return prevClone;
        });
    };

    const onChangeSettingWebCrawler = e => {
        let name = e.target.name;
        let value = e.target.value;

        switch (name) {
            case Constant.UPLOAD_CSV_KNOWLEDGE.LAYER_SETTINGS:
                setLayer(parseInt(value));
                break;

            case Constant.UPLOAD_CSV_KNOWLEDGE.FILE_TYPE_SETTINGS:
                setFileTypes(value);
                break;

            case Constant.UPLOAD_CSV_KNOWLEDGE.USER_NAME_SETTINGS:
                setUserName(value);
                break;

            case Constant.UPLOAD_CSV_KNOWLEDGE.PASSWORD_SETTINGS:
                setPassword(value);
                break;

            default:
                break;
        }
        setIsEdited(true);
    };

    return (
        <div className="groupUpload">
            <div
                className="accordionHead-SettingTitle"
                onClick={() => setIsShowSettingPermission(prev => !prev)}
            >
                <img src="/assets/image/setting-title.svg" alt="setting-title" />
                <span className="text">{trI18n('KNOWCRLB004')}</span>
                {isShowSettingPermission ? (
                    <img src="/assets/image/icon-minus-accordion.svg" alt="minus" />
                ) : (
                    <img src="/assets/image/icon-plus-accordion.svg" alt="plus" />
                )}
            </div>
            <div
                className={`${
                    isShowSettingPermission
                        ? 'setting-permission-body'
                        : 'setting-permission-body-none'
                } setting-crawler-wrapper`}
            >
                {/* setting layer  */}
                <div className="column-setting-layer">
                    <div className="row-setting-layer">
                        <label className="label-web-crawler">{trI18n('KNOWCRLB012')}</label>
                        {/* <Tooltip
                            title={getContentTooltip()}
                            placement="bottom-end"
                        >
                            <img src="/assets/image/icon-info-mark.svg" alt="" />
                        </Tooltip> */}
                    </div>

                    <FormControl>
                        <RadioGroup
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name={Constant.UPLOAD_CSV_KNOWLEDGE.LAYER_SETTINGS}
                            value={layer}
                            onChange={e => onChangeSettingWebCrawler(e)}
                            defaultValue={Constant.UPLOAD_CSV_KNOWLEDGE.MIN_LAYER}
                        >
                            <FormControlLabel
                                style={{ pointerEvents: 'none' }}
                                value={Constant.UPLOAD_CSV_KNOWLEDGE.MIN_LAYER}
                                control={
                                    <Radio
                                        style={{ pointerEvents: 'auto' }}
                                        checked={layer === Constant.UPLOAD_CSV_KNOWLEDGE.MIN_LAYER}
                                        icon={<CheckIconRadio />}
                                        checkedIcon={<CheckedIconRadio />}
                                    />
                                }
                                label={trI18n('KNOWCRLB036')}
                                disabled={isDisabledAllFieldCsv(handleStatus)}
                            />
                            <FormControlLabel
                                style={{ pointerEvents: 'none' }}
                                value={Constant.UPLOAD_CSV_KNOWLEDGE.MAX_LAYER}
                                control={
                                    <Radio
                                        style={{ pointerEvents: 'auto' }}
                                        checked={layer === Constant.UPLOAD_CSV_KNOWLEDGE.MAX_LAYER}
                                        icon={<CheckIconRadio />}
                                        checkedIcon={<CheckedIconRadio />}
                                    />
                                }
                                label={trI18n('KNOWCRLB037')}
                                disabled={isDisabledAllFieldCsv(handleStatus)}
                            />
                        </RadioGroup>
                    </FormControl>
                </div>

                {/* setting file type  */}
                <div className="row-setting-layer">
                    <div className="label-web-crawler">
                        {trI18n('KNOWCRLB013')}
                        &nbsp;
                        <span className="required">*</span>
                    </div>
                    <TextField
                        name={Constant.UPLOAD_CSV_KNOWLEDGE.FILE_TYPE_SETTINGS}
                        className="form-control form-control--wrap form-control--hg40 edit-org-input input-setting-layer"
                        variant="outlined"
                        value={fileTypes}
                        placeholder={trI18n('KNOWCRP002')}
                        onChange={e => onChangeSettingWebCrawler(e)}
                        onBlur={e => onBlurFileTypes(e)}
                        helperText={!Utils.isEmptyObject(errorList) && tr(errorList?.fileTypes)}
                        error={!Utils.isEmptyObject(errorList) && errorList?.fileTypes}
                        disabled={isDisabledAllFieldCsv(handleStatus)}
                    />
                </div>

                {/* setting authentication  */}
                <div className="authen-crawler-wraper">
                    <div className="label-web-crawler">{trI18n('KNOWCRLB006')}</div>
                    <FormControl>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue={trI18n('KNOWCRLB015')}
                            name="radio-buttons-group"
                        >
                            <FormControlLabel
                                disabled
                                value={trI18n('KNOWCRLB014')}
                                control={<Radio icon={<IconDisabledRadio />} />}
                                label={trI18n('KNOWCRLB014')}
                            />
                            <FormControlLabel
                                disabled={isDisabledAllFieldCsv(handleStatus)}
                                value={trI18n('KNOWCRLB015')}
                                control={<Radio checkedIcon={<CheckedIconRadio />} />}
                                label={trI18n('KNOWCRLB015')}
                            />
                        </RadioGroup>
                    </FormControl>

                    {/* user name and password  */}
                    <div className="formLogin">
                        <div className="row-setting-authen">
                            <label className="label-web-crawler">{trI18n('KNOWCRLB005')}</label>
                            <TextField
                                name={Constant.UPLOAD_CSV_KNOWLEDGE.USER_NAME_SETTINGS}
                                className="form-control form-control--wrap form-control--hg40 edit-org-input input-setting-layer"
                                variant="outlined"
                                value={userName}
                                placeholder={trI18n('KNOWCRP003')}
                                onChange={e => onChangeSettingWebCrawler(e)}
                                onBlur={e => onBlurAuthenticatedUsername(e)}
                                helperText={!Utils.isEmptyObject(errorList) && tr(errorList?.userName)}
                                error={!Utils.isEmptyObject(errorList) && errorList?.userName}
                                disabled={isDisabledAllFieldCsv(handleStatus)}
                            />
                        </div>

                        <div className="row-setting-authen">
                            <label className="label-web-crawler">{trI18n('AUTH01LB002')}</label>
                            <TextField
                                name={Constant.UPLOAD_CSV_KNOWLEDGE.PASSWORD_SETTINGS}
                                className="form-control form-control--wrap form-control--hg40 edit-org-input input-setting-layer"
                                variant="outlined"
                                type="password"
                                value={password}
                                placeholder={trI18n('COMM01MSG05')}
                                onChange={e => onChangeSettingWebCrawler(e)}
                                onBlur={e => onBlurAuthenticatedPassword(e)}
                                helperText={!Utils.isEmptyObject(errorList) && tr(errorList?.password)}
                                error={!Utils.isEmptyObject(errorList) && errorList?.password}
                                disabled={isDisabledAllFieldCsv(handleStatus)}
                                inputProps={{
                                    autoComplete: 'new-password',
                                    form: {
                                        autoComplete: 'off'
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
